import styled from 'styled-components';
import { getTheme } from '@buildersbank/theme-toolkit';
import { TextField } from '@material-ui/core';

const brandPrimaryMain = getTheme('brand.primary.main');

export const Input = styled(TextField)`
  & label {
    font-size: 1em;
  }
  & label.Mui-focused {
    color: ${brandPrimaryMain};
  }
  & .MuiInput-underline:after {
    border-bottom-color: ${brandPrimaryMain};
  }
`;

export const InputWrapper = styled.div`
  flex-direction: column;
`;
